// @flow

import { checkHttpStatus } from '../utils/api'
import { getLoggingProjectId, getLoggingToken } from '../utils'
import type { APIError } from '../types'
import type { Action } from '../types/actions/logging'
import { getErrorAction } from '../utils/actions'

export const POST_LOGGING_REQUEST = 'POST_LOGGING_REQUEST'
export const POST_LOGGING_SUCCESS = 'POST_LOGGING_SUCCESS'
export const POST_LOGGING_FAILURE = 'POST_LOGGING_FAILURE'

export function postLoggingRequest(): Action {
  return {
    type: POST_LOGGING_REQUEST
  }
}

export function postLoggingSuccess(): Action {
  return {
    type: POST_LOGGING_SUCCESS
  }
}

export function postLoggingFailure(error: APIError): Action {
  return getErrorAction(
    POST_LOGGING_FAILURE,
    error,
    'There was an error logging analytics information.'
  )
}

export function postToLoggingServiceSimple(
  collection: string,
  data: Object
): Function {
  return async (dispatch, getState) => {
    const appVersion = document.getElementById('appVersion')
    const body = {
      application: 'QW',
      appVersion: appVersion ? appVersion.innerHTML : '',
      ...data
    }

    dispatch(postLoggingRequest())

    try {
      checkHttpStatus(
        await fetch(
          `https://oe-log-service.herokuapp.com/api/projects/${getLoggingProjectId()}/events/${collection}`,
          {
            method: 'POST',
            headers: {
              Authorization: getLoggingToken(),
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(Object.assign(body, data))
          }
        )
      )

      dispatch(postLoggingSuccess())
    } catch (error) {
      dispatch(postLoggingFailure(error))
    }
  }
}


export function postToLoggingService(
  collection: string,
  data: Object
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const user = state.auth.user
    const currentOrg = user.organizations.find(function (org) {
      return org.id === state.organization.orgId
    })
    const appVersion = document.getElementById('appVersion')
    const body = {
      application: 'QW',
      appVersion: appVersion ? appVersion.innerHTML : '',
      user: user.guardian_user ? {
        id: user.guardianUserData.id,
        name: user.guardianUserData.name,
        mentor: false,
        student: false
      } : {
        id: user.id,
        roles: user.organization_roles,
        name: user.name,
        mentor: state.auth.isMentor,
        student: !state.auth.isMentor
      },
      organization: {
        id: state.organization.orgId,
        name: currentOrg ? currentOrg.name : null
      }
    }

    dispatch(postLoggingRequest())

    try {
      checkHttpStatus(
        await fetch(
          `https://oe-log-service.herokuapp.com/api/projects/${getLoggingProjectId()}/events/${collection}`,
          {
            method: 'POST',
            headers: {
              Authorization: getLoggingToken(),
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(Object.assign(body, data))
          }
        )
      )

      dispatch(postLoggingSuccess())
    } catch (error) {
      dispatch(postLoggingFailure(error))
    }
  }
}

// UGH!
export function postToLoggingServiceNotAuthenticated(
  collection: string,
  data: Object
): Function {
  return async dispatch => {
    const appVersion = document.getElementById('appVersion')
    const body = {
      application: 'QW',
      appVersion: appVersion ? appVersion.innerHTML : ''
    }

    dispatch(postLoggingRequest())

    try {
      checkHttpStatus(
        await fetch(
          `https://oe-log-service.herokuapp.com/api/projects/${getLoggingProjectId()}/events/${collection}`,
          {
            method: 'POST',
            headers: {
              Authorization: getLoggingToken(),
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(Object.assign(body, data))
          }
        )
      )

      dispatch(postLoggingSuccess())
    } catch (error) {
      dispatch(postLoggingFailure(error))
    }
  }
}
